import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Link } from 'react-router-dom'
import Notifications from 'react-notification-system-redux'
import validator from 'validator'
import { FormattedMessage, injectIntl } from 'react-intl'

import { Form, InputField } from '../../../common/form'
import { getAuthInProgress, getAuthError } from '../selectors'
import { LoadingOverlay } from '../../../common/loading_overlay'

import { url } from '../../../common/helpers'
import * as actionCreators from '../actionCreators'

class LoginForm extends Component {
    validationRules = {
        email: value => validator.isEmpty(value) && this.props.intl.formatMessage({ id: 'validator.email.required' }),
        password: value => validator.isEmpty(value) && this.props.intl.formatMessage({ id: 'validator.password.required' }),
    }

    handleSubmit = values => {
        values.language = this.props.intl.locale ? this.props.intl.locale : 'cs'
        this.props.actions.login(values)
    }

    componentWillReceiveProps(nextProps) {
        // Login successful
        if (this.props.inProgress && !nextProps.inProgress && nextProps.loginError === null) {
            this.props.redirect('/transports')
        }

        // Login error
        if (this.props.inProgress && !nextProps.inProgress && nextProps.loginError !== null) {
            this.props.notify(
                {
                    title: this.props.intl.formatMessage({ id: 'alerts.titles.error' }),
                    message: this.props.intl.formatMessage({
                        id: nextProps.loginError.get('error_code')
                            ? `alerts.messages.code.${nextProps.loginError.get('error_code')}`
                            : 'alerts.messages.loginFailed',
                    }),
                    position: 'tc',
                },
                'error'
            )
        }
    }

    render() {
        return (
            <div>
                <p className="text-center m-t-md">
                    <FormattedMessage id="login.login" />
                </p>
                <Form values={{}} validationRules={this.validationRules} onSubmit={this.handleSubmit}>
                    <LoadingOverlay active={this.props.inProgress} dark>
                        <InputField
                            id="email"
                            placeholder={this.props.intl.formatMessage({
                                id: 'fields.email',
                            })}
                        />
                        <InputField
                            type="password"
                            id="password"
                            placeholder={this.props.intl.formatMessage({
                                id: 'fields.password',
                            })}
                        />
                        <button type="submit" className="btn btn-success btn-block">
                            <FormattedMessage id="buttons.signIn" />
                        </button>
                    </LoadingOverlay>
                </Form>
                <p className="text-center m-t-md">
                    <Link to={url(this.props.match, 'auth/login/forgotten-password-form')}>
                        <FormattedMessage id="login.forgottenPassword" />
                    </Link>
                </p>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        inProgress: getAuthInProgress(state),
        loginError: getAuthError(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actionCreators, dispatch),
        redirect: toURL => dispatch(push(toURL)),
        notify: (notification, type) => dispatch(Notifications.show(notification, type)),
    }
}

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(LoginForm)
)
